import { ProFormColumnsType } from '@ant-design/pro-components';
import { FormattedMessage } from 'react-intl';
import { NUMBER_REGEXP } from '../../../../common/regexp';

export const createCurrencyFormItem = (
  group: string | null,
  itemKey: string,
  subKey = 'household',
  suffix?: string,
  isRequired?: boolean,
): ProFormColumnsType =>
  ({
    title: <FormattedMessage id={`btlApplicationForm.TOP_SLICING_HOUSEHOLD.${subKey}.${itemKey}.label`} />,
    dataIndex: group ? [group, itemKey] : [itemKey],
    valueType: { type: 'money', locale: 'en-GB' },
    width: 300,
    fieldProps: {
      precision: 0,
      placeholder: '£',
      suffix,
    },
    formItemProps: {
      hasFeedback: isRequired,
      rules: [
        {
          required: isRequired,
          message: <FormattedMessage id={'common.error.minNumber'} values={{ min: 0 }} />,
        },
        {
          min: 0,
          pattern: NUMBER_REGEXP,
          message: <FormattedMessage id={'btlApplicationForm.TOP_SLICING_HOUSEHOLD.greaterThanZero.error'} />,
          type: 'number',
        },
      ],
    },
  } as ProFormColumnsType);
